<template>
  <div class="honour">
    <TabBar_m />
    <div class="banner"></div>
    <div class="title">
      <h6>Honor and certification</h6>
      <i></i>
      <h3>荣誉与认证</h3>
    </div>
    <div class="honour_img_box" v-viewer>
      <div class="honour_item">
        <div class="img_box">
          <img src="../assets/image_m/honour_1.png" alt />
        </div>
        <span>高新技术企业证书</span>
      </div>
      <div class="honour_item">
        <div class="img_box">
          <img src="../assets/image_m/honour_2.png" alt />
        </div>
        <span>陕西省AAA级信誉单位</span>
      </div>
      <div class="honour_item">
        <div class="img_box">
          <img src="../assets/image_m/honour_3.png" alt />
        </div>
        <span>中国互联网协会理事单位</span>
      </div>
      <div class="honour_item">
        <div class="img_box">
          <img src="../assets/image_m/honour_4.png" alt />
        </div>
        <span>诚信经营签约单位</span>
      </div>
      <div class="honour_item">
        <div class="img_box">
          <img src="../assets/image_m/honour_5.png" alt />
        </div>
        <span>创业企业观察点</span>
      </div>
    </div>
    <div class="huawei_img_box" v-viewer>
      <div class="huawei_item">
        <div class="huawei_img">
          <img src="../assets/images/cert_6.jpg" alt />
        </div>
        <span>华为技术认证书</span>
      </div>
      <div class="huawei_item">
        <div class="huawei_img">
          <img src="../assets/images/cert_7.jpg" alt />
        </div>
        <span>华为技术认证书</span>
      </div>
    </div>
    <Footer_m />
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.banner {
  background: url("../assets/image_m/brief_bgc.png") no-repeat;
  background-position: center;
  background-size: 100%;
  margin-top: 50px;
  &::before {
    content: "";
    padding-top: 100%;
    display: block;
  }
}
.title {
  padding: 16px;
  h6 {
    line-height: 15px;
    font-size: 10px;
    text-transform: uppercase;
  }
  i {
    display: block;
    width: 30px;
    height: 2px;
    background: #26acff;
    margin: 4px 0;
  }
  h3 {
    line-height: 25px;
    font-size: 18px;
    margin-bottom: 12px;
  }
}
.honour_img_box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 16px;
  .honour_item {
    width: 48%;
    text-align: center;
    margin-bottom: 12px;
    .img_box {
      border: 1px solid #dedede;
      padding: 8px;
      margin-bottom: 8px;
      img {
        width: 100%;
      }
    }
    span {
      line-height: 17px;
      font-size: 12px;
    }
  }
}
.huawei_img_box {
  display: flex;
  justify-content: space-between;
  padding: 0 16px;
  .huawei_item {
    width: 48%;
    text-align: center;
    span {
      line-height: 17px;
      font-size: 12px;
    }
    .huawei_img {
      img {
        width: 100%;
      }
    }
  }
}
</style>